/**
* Card Set Two JS
* -----------------------------------------------------------------------------
*
* All the JS for the Card Set Two component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase.js';

( function( app ) {
  const COMPONENT = {

    className: 'card-set-two',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let tallest = 0;

      const promise = new Promise( function() {
        $( '.card-set-two .get-height' ).each( function() {
          const thisHeight = this.clientHeight;
          if ( thisHeight > tallest ) {
            tallest = thisHeight;
          }
        } );
      } );

      promise.then( $( '.card-set-two .get-height' ).each( function() {
        this.style.height = tallest+'px';
      } )
      );

      gsap.registerPlugin( ScrollTrigger );
      gsap.registerPlugin( CustomEase );

      CustomEase.create( 'fastForward', ' 0.390, 0.575, 0.565, 1.000 ' );

      $( '.card-wrapper.set-two .arrows .icon' ).each( function() {
        gsap.from( this, {
          scrollTrigger: {
            trigger: this,
            start: 'top 60%',
            scrub: false,
          },
          x: '-115vw',
          duration: 0.9,
          ease: 'fastForward',
          stagger: {
            each: .15,
            from: 2,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'card-set-two', COMPONENT );
} )( app );
